class MemberGroupForm {
    constructor(formID, memberGroupInfo = null, initOnlyMemberGroupModalFromMemberModal = false) {
        this.organizationID = new URLSearchParams(window.location.search).get('organizationID');
        this.form = document.getElementById(formID);
        this.modal = this.form.querySelector('.modal');
        this.addMembersToGroupForm = memberGroupInfo ?
            document.getElementById('frm-addMembersToEditMemberGroupForm-addMembersToEditMemberGroupForm') :
            document.getElementById('frm-addMembersToMemberGroupForm-addMembersToMemberGroupForm');
        this.addMembersToGroupModal = this.addMembersToGroupForm.querySelector('.modal');
        this.memberGroupDatatableEl = this.form.querySelector('#member-group-members-datatable')
        this.memberGroupInfo = memberGroupInfo;
        this.memberGroupsDatatable = null;
        this.openModalAfterSubmit = null;

        if(initOnlyMemberGroupModalFromMemberModal){
            this.openMemberGroupModalFromMemberModal();
        } else {
            this.initAll();
        }
    }
    initAll(){
        if(this.form && this.modal){
            this.initMembersDatatable();
            this.memberGroupFormValidation();

            if(this.memberGroupInfo){
                this.hideGeneralModals();
                this.initDeleteMemberGroup();
            }
        }
    }
    openMemberGroupModalFromMemberModal(){
        const thisClass = this;
        $(document).on('click', '.open-add-group-modal', function (e) {
            if(!thisClass.memberGroupsDatatable){
                thisClass.initAll();
            }
            let modal = document.getElementById($(this).attr('data-modal-id'));
            if(modal){
                thisClass.openModalAfterSubmit = modal;
                let usernameInvite = modal.querySelector('input[name="UsernameInvite"]');
                let username = modal.querySelector('input[name="Username"]');
                let password = modal.querySelector('input[name="Password"]');
                if(usernameInvite && usernameInvite.value){
                    let emails = JSON.parse(usernameInvite.value);
                    thisClass.usernameInvites = emails.map(item => item.value);
                }
                if(username){
                    thisClass.deviceUsername = username.value;
                }
                if(password){
                    thisClass.devicePassword = password.value;
                }
            }
            bootstrap.Modal.getOrCreateInstance(modal, {}).hide();
            bootstrap.Modal.getOrCreateInstance(thisClass.modal, {}).show();
        });
    }
    redrawAddMemberSnippet(submitButton){
        const thisClass = this;
        naja.makeRequest('GET', '/team-members/?do=redrawAddMemberSnippet', {
            'organizationID': thisClass.organizationID
        }, {
            history: false // Prevent URL changes in browser history
        }).then(async (response) => {
            if (response) {
                new Members(response.vpnUsernames, response.memberGroups, true);

                thisClass.openModalAfterSubmit = document.getElementById(thisClass.openModalAfterSubmit.id); // get new instance after redraw

                if (thisClass.usernameInvites) {
                    let usernameInvite = thisClass.openModalAfterSubmit.querySelector('input[name="UsernameInvite"]');
                    if (usernameInvite && usernameInvite.__tagify) {
                        usernameInvite.__tagify.addTags(thisClass.usernameInvites);
                    }
                }
                if (thisClass.deviceUsername) {
                    let username = thisClass.openModalAfterSubmit.querySelector('input[name="Username"]');
                    if (username) {
                        username.value = thisClass.deviceUsername;
                    }
                }
                if (thisClass.devicePassword) {
                    let password = thisClass.openModalAfterSubmit.querySelector('input[name="Password"]');
                    if (password) {
                        password.value = thisClass.devicePassword;
                    }
                }
                let groups = thisClass.openModalAfterSubmit.querySelector('input[name="groups"]');
                if (groups && groups.__tagify && response.memberGroups) {
                    groups.__tagify.addTags(response.memberGroups);
                }

                new DismissModal(thisClass.modal.id).enable();
                bootstrap.Modal.getInstance(thisClass.modal).hide();
                new bootstrap.Modal(thisClass.openModalAfterSubmit).show();
                if(!thisClass.memberGroupInfo){
                    thisClass.clearForm();
                }
                submitButton.setAttribute('data-kt-indicator', 'off');
                submitButton.disabled = false;
                thisClass.openModalAfterSubmit = false;
                thisClass.usernameInvites = [];
                thisClass.deviceUsername = '';
                thisClass.devicePassword = '';
            }
        });
    }
    initMembersDatatable(){
        const thisClass = this;
        if(!this.memberGroupsDatatable){
            /** Add loading for the whole edit group modal */
            const blockUI = new KTBlockUI(this.modal.querySelector('.modal-content'), {
                overlayClass: "ga-bg-primary-200",
            });
            blockUI.block();
            
            /** init member groups members datatable */
            this.memberGroupsDatatable = new MemberGroupMembersDatatable(this.memberGroupInfo ? this.memberGroupInfo.uuid : null,
                this.memberGroupInfo ? this.memberGroupInfo.numberOfMembers : 0, this.memberGroupDatatableEl, this.modal);

            /** After Members datatable in edit group modal is initialized - do some action */
            $(thisClass.form).find('#member-group-members-datatable').on( 'init.dt', function () {
                let datatable = $(this).DataTable();

                /** If all members is in group - disable button for add members to group */
                let membersNotInGroup = datatable.rows('.not-in-group.d-none').data().toArray();
                let addMembersToMemberGroupButton = thisClass.form.querySelector('#addMembersToMemberGroup');
                if(membersNotInGroup.length === 0){
                    addMembersToMemberGroupButton.setAttribute('disabled', 'true');
                }

                /** If user close add modal - show edit vpn user group modal */
                $(thisClass.addMembersToGroupModal).on('hide.bs.modal', function () {
                    bootstrap.Modal.getInstance(thisClass.modal, {}).show();
                });

                /** After click on add members to group */
                addMembersToMemberGroupButton.addEventListener('click', function () {
                    /** initialize tagify input for adding members to group */
                    let membersNotInGroup = datatable.rows('.not-in-group.d-none').data().toArray();
                    thisClass.initAddMembersToGroupTagify(membersNotInGroup);

                    /** Open add members to group modal */
                    bootstrap.Modal.getInstance(thisClass.modal).hide();
                    bootstrap.Modal.getOrCreateInstance(thisClass.addMembersToGroupModal, {}).show();
                });
                
                /** Init validation for add members to group */
                thisClass.addMembersToMemberGroupFormValidation(datatable);
                /** Init removing from datatable */
                thisClass.removeMemberFromMemberGroup(datatable);
                /** Create scroll instances - make modal fit in window */
                KTScroll.createInstances();
                /** Remove modal loading - everything is set */
                blockUI.release();

                $.nette.load();
            });
        }
    }
    memberGroupFormValidation(){
        const thisClass = this;
        let submitButton = this.form.querySelector('[data-custom-action="submit"]');

        let validator = FormValidation.formValidation(this.form,
            {
                fields: {
                    'name': {
                        validators: {
                            notEmpty: {
                                message: 'This field is required',
                            },
                            stringLength: {
                                stringLength: {
                                    min: 3,
                                    max: 45,
                                    message: 'Group name must have at least 3 characters',
                                },
                            },
                            regexp: {
                                regexp: /^(?! )[-\w\._\(\)# ]+$/,
                                message: 'You used an invalid character',
                            },
                        }
                    },
                },
                plugins: {
                    trigger: new FormValidation.plugins.Trigger(),
                    autoFocus: new FormValidation.plugins.AutoFocus(),
                    submitButton: new FormValidation.plugins.SubmitButton(),
                    // defaultSubmit: new FormValidation.plugins.DefaultSubmit(), // Uncomment this line to enable normal button submit after form validation
                    bootstrap: new FormValidation.plugins.Bootstrap5({
                        rowSelector: '.fv-row',
                        eleInvalidClass: '',
                        eleValidClass: ''
                    }),
                }
            }
        );

        submitButton.addEventListener('click', function (e) {
            // Prevent default button action
            e.preventDefault();
            validator.validate().then(function(status) {
                if(status === 'Valid'){
                    new DismissModal(thisClass.modal.id).disable();
                    // Show loading indication
                    submitButton.setAttribute('data-kt-indicator', 'on');
                    // Disable button to avoid multiple click
                    submitButton.disabled = true;
                    $(thisClass.form).submit();
                }
            });
        });

        let context = $.nette.ext(thisClass.form.id);
        if(!context) {
            $.nette.ext(thisClass.form.id, {
                success: function (payload, status, jqXHR, settings) {
                    let formID = settings.nette.form[0].attributes.id.value;
                    if (formID === thisClass.form.id) {
                        thisClass.modal = document.getElementById(thisClass.modal.id);

                        if (payload.success) {
                            toastr.success(payload.message);
                        } else {
                            toastr.error('Unexpected error occurred. Please try it again later or contact our support team.')
                        }

                        if(thisClass.openModalAfterSubmit){
                            thisClass.redrawAddMemberSnippet(submitButton);
                        } else {
                            new DismissModal(thisClass.modal.id).enable();
                            bootstrap.Modal.getInstance(thisClass.modal).hide();
                            if(!thisClass.memberGroupInfo){
                                thisClass.clearForm();
                            }
                            // Show loading indication
                            submitButton.setAttribute('data-kt-indicator', 'off');
                            // Disable button to avoid multiple click
                            submitButton.disabled = false;
                        }
                        let numberOfGroupsElement = $(".number-of-groups");
                        if(numberOfGroupsElement){
                            numberOfGroupsElement.text(parseInt(numberOfGroupsElement.text()) + 1);
                        }

                        new PageDatatableReload(false, [thisClass.memberGroupDatatableEl.id]);
                    }
                }
            });
        }
    }
    clearForm(){
        let nameElement = this.form.querySelector('input[name="name"]');
        nameElement.value = this.getNewMemberGroupName(nameElement.value);

        this.memberGroupsDatatable.resetDatatable();
    }
    getNewMemberGroupName(name) {
        const regex = /^Member Group #(\d+)$/;
        const match = name.match(regex);
        if (match) {
            const number = parseInt(match[1], 10);
            const incrementedNumber = number + 1;
            return `Member Group #${incrementedNumber}`;
        }
        return '';
    }
    initDeleteMemberGroup(){
        const thisClass = this;
        const deleteGroupButton = this.modal.querySelector('button.delete-member-group');
        if(deleteGroupButton){
            deleteGroupButton.addEventListener('click', function () {
                let html = '';
                if(thisClass.memberGroupInfo.accessCards){
                    html += `<span class="text-center text-primary">Group `+(thisClass.memberGroupInfo.name !== undefined ? `<b>`+thisClass.memberGroupInfo.name+`</b> ` : ``)+`is going to be completely deleted! Deleting this Group will affect the access rights of Members in this Group.</span>`;
                } else {
                    html += `<span class="text-center text-primary">Group `+(thisClass.memberGroupInfo.name !== undefined ? `<b>`+thisClass.memberGroupInfo.name+`</b> ` : ``)+`is going to be completely deleted!</span>`;
                }
                Swal.fire({
                    html: html,
                    icon: "warning",
                    iconColor: "#FF5206",
                    buttonsStyling: false,
                    reverseButtons: true,
                    showCancelButton: true,
                    confirmButtonText: "Yes, delete!",
                    customClass: {
                        confirmButton: "btn btn-danger mt-0",
                        cancelButton: 'btn btn-light-primary mt-0',
                    },
                    showLoaderOnConfirm: true,
                    returnFocus: false,
                    preConfirm: () => {
                        return fetch('/team-members/?do=removeVpnUserGroup&organizationID='+thisClass.organizationID+'&vpnUserGroupID='+thisClass.memberGroupInfo.uuid)
                            .then(response => {
                                if (!response.ok) {
                                    throw new Error(response.statusText)
                                }
                                return response.json();
                            }).catch(error => {
                                Swal.showValidationMessage(`Request failed: ${error}`)
                            });
                    },
                    allowOutsideClick: () => !Swal.isLoading(),
                    allowEscapeKey: () => !Swal.isLoading()
                }).then((result) => {
                    if (result.isConfirmed) {
                        if(result.value === 'deleted') {
                            toastr.success('Group has been deleted.');
                            bootstrap.Modal.getInstance(thisClass.modal).hide();
                            new PageDatatableReload();

                            let numberOfGroupsElement = $(".number-of-groups");
                            if(numberOfGroupsElement){
                                numberOfGroupsElement.text(numberOfGroupsElement.text() - 1);
                            }
                        }
                    }
                });
            });
        }
    }
    hideGeneralModals(){
        let editMemberModal = document.getElementById('edit_member_modal');
        if(editMemberModal && editMemberModal.classList.contains('show')){
            bootstrap.Modal.getInstance(editMemberModal).hide();
            new AddBackLinkToModal(editMemberModal, this.modal);
        }
        let editAccessCardModal = document.getElementById('edit_access_card_modal');
        if(editAccessCardModal && editAccessCardModal.classList.contains('show')){
            bootstrap.Modal.getInstance(editAccessCardModal).hide();
            new AddBackLinkToModal(editAccessCardModal, this.modal);
        }
        let createAccessCardModal = document.getElementById('create_access_card_modal');
        if(createAccessCardModal && createAccessCardModal.classList.contains('show')){
            bootstrap.Modal.getInstance(createAccessCardModal).hide();
            new AddBackLinkToModal(createAccessCardModal, this.modal);
        }
    }
    initAddMembersToGroupTagify(members){
        const inputElm = this.addMembersToGroupForm.querySelector('input[name=membersToAdd]');
        /** Destroy tagify on input - we want new instance if tagify already exist */
        if(inputElm.__tagify){
            inputElm.value = '';
            inputElm.__tagify.destroy();
        }

        /** Adding values - tagify needs 'value' */
        for(let i in members){
            members[i]['value'] = members[i]['uuid'];
        }
        /** Initialize tagify input for adding members to group */
        new MembersTagify(inputElm, members);
    }
    addMembersToMemberGroupFormValidation(datatable){
        let thisClass = this;
        if(this.addMembersToGroupForm){
            let submitButton = this.addMembersToGroupForm.querySelector('#add_members_to_member_group_modal_submit');

            let validator = FormValidation.formValidation(
                this.addMembersToGroupForm,
                {
                    fields: {
                        'membersToAdd': {
                            validators: {
                                notEmpty: {
                                    message: 'This field is required'
                                },
                            }
                        },
                    },
                    plugins: {
                        trigger: new FormValidation.plugins.Trigger(),
                        autoFocus: new FormValidation.plugins.AutoFocus(),
                        bootstrap: new FormValidation.plugins.Bootstrap5({
                            rowSelector: '.fv-row',
                            eleInvalidClass: '',
                            eleValidClass: ''
                        }),
                    }
                }
            );

            const submitForm = () => {
                if (validator) {
                    validator.validate().then(function (status) {
                        if (status === 'Valid') {
                            /** Disable dismiss modal and add loader */
                            new DismissModal(thisClass.addMembersToGroupModal.id).disable();
                            submitButton.setAttribute('data-kt-indicator', 'on');
                            submitButton.disabled = true;

                            /** Get selected members from tagify and show them in table */
                            let membersMemberGroupDatatable =  $(thisClass.modal).find('#member-group-members-datatable');
                            let selectedMembers = JSON.parse($(thisClass.addMembersToGroupModal).find('input[name=membersToAdd]').val());
                            for (const i in selectedMembers) {
                                if(selectedMembers[i]['uuid']){
                                    let tableRowInput = membersMemberGroupDatatable.find('input[value='+selectedMembers[i]['uuid']+']');
                                    if(tableRowInput){
                                        tableRowInput.prop('checked', true);
                                        tableRowInput.closest('tr').removeClass('d-none not-in-group');
                                    }
                                }
                            }

                            thisClass.afterAddOrRemoveEvents(datatable);

                            /** Show back edit modal and enable dismiss modal */
                            bootstrap.Modal.getInstance(thisClass.addMembersToGroupModal).hide();
                            bootstrap.Modal.getInstance(thisClass.modal, {}).show();
                            submitButton.setAttribute('data-kt-indicator', 'off');
                            submitButton.disabled = false;
                            new DismissModal(thisClass.addMembersToGroupModal.id).enable();
                        }
                    });
                }
            }

            submitButton.addEventListener('click', function (e) {
                // Prevent default button action
                e.preventDefault();
                // Validate form before submit
                submitForm();
            });

            this.addMembersToGroupForm.addEventListener("submit", function(e) {
                // Prevent default button action
                e.preventDefault();
                // Validate form before submit
                submitForm();
            }, true);
        }
    }
    removeMemberFromMemberGroup(datatable){
        let thisClass = this;
        let removeMemberButtons = $(thisClass.form).find('.remove-member-from-group');
        removeMemberButtons.on('click', function() {
            let row = $(this).closest('tr');
            row.find('input[name=members\\[\\]]').prop('checked', false);
            row.addClass('d-none not-in-group');
            thisClass.afterAddOrRemoveEvents(datatable);
        });
        let removeAllMemberButtons = $(thisClass.form).find('.remove-all-members-from-group');
        removeAllMemberButtons.on('click', function() {
            let removeButtons = $(thisClass.form).find('tr .remove-member-from-group');
            for (let i = 0; i < removeButtons.length; i++) {
                let row = $(removeButtons[i]).closest('tr');
                row.find('input[name=members\\[\\]]').prop('checked', false);
                row.addClass('d-none not-in-group');
            }
            thisClass.afterAddOrRemoveEvents(datatable);
        });
    }
    afterAddOrRemoveEvents(datatable){
        const thisClass = this;
        /** If there is notice that group is in access card - show it */
        let notice = $('#addOrDeleteMemberNotice');
        if(notice){
            notice.removeClass('d-none');
        }

        /** Change button text and add swal on close button */
        let cancelButton = $(this.modal.querySelector('#member_group_form_cancel'));
        if(cancelButton){
            new DismissModal(this.modal.id).disable(true);
            cancelButton.html('Discard Changes');

            let closeButton = $('#'+this.modal.id+' .close-button[data-bs-dismiss]');
            if(closeButton){
                if(this.memberGroupInfo){
                    closeButton.removeAttr('data-bs-dismiss');
                    closeButton.on('click', function (e) {
                        Swal.fire({
                            html: `<span class="text-center text-primary">You have made changes to this Group. Do you want to save them?</span>`,
                            icon: "question",
                            iconColor: "#FF5206",
                            buttonsStyling: false,
                            reverseButtons: true,
                            showCancelButton: true,
                            cancelButtonText: "Discard Changes",
                            confirmButtonText: "Save",
                            returnFocus: false,
                            customClass: {
                                confirmButton: "btn btn-danger mt-0",
                                cancelButton: 'btn btn-light-primary mt-0',
                            },
                        }).then((result) => {
                            if (result.isConfirmed) {
                                /** Remove event listener on click */
                                closeButton.off();
                                /** Disable dismiss modal, add loader to submit button and disable delete button */
                                new DismissModal('edit_member_group_modal').disable();
                                let submitButton = thisClass.form.querySelector('#member_group_form_submit');
                                submitButton.setAttribute('data-kt-indicator', 'on');
                                submitButton.disabled = true;
                                let deleteButton = thisClass.form.querySelector('#edit_member_group_form_delete');
                                deleteButton.disabled = true;
                                /** Submit form */
                                $(thisClass.form).submit();
                            } else if(result.dismiss === 'cancel') {
                                /** Discard changes - hide modal */
                                bootstrap.Modal.getInstance(thisClass.modal, {}).hide();
                            }
                        });
                    })
                }
            }
        }

        let membersInGroup = datatable.rows(':not(.not-in-group.d-none)').data().toArray();
        let membersNotInGroup = datatable.rows('.not-in-group.d-none').data().toArray();

        $(this.modal).find('#member_group_members_selected').text(membersInGroup.length);

        /** Enabling/disabling the add button depends on whether there are still members to add */
        let addMembersToMemberGroupButton = this.modal.querySelector('#addMembersToMemberGroup');
        if(membersNotInGroup.length === 0){
            addMembersToMemberGroupButton.setAttribute('disabled', 'true');
        } else {
            addMembersToMemberGroupButton.removeAttribute('disabled');
        }

        /** Show/hide datatable no results */
        if(membersInGroup.length === 0){
            $(this.modal).find('#member-group-members-datatable_wrapper').hide();
            $(this.modal).find('#member-group-members-datatable_no-results').addClass('d-flex flex-center flex-column').removeClass('d-none');
        } else {
            $(this.modal).find('#member-group-members-datatable_wrapper').show();
            $(this.modal).find('#member-group-members-datatable_no-results').removeClass('d-flex flex-center flex-column').addClass('d-none');
        }
    }
}
window.MemberGroupForm = MemberGroupForm;